import { Component, Injector, OnInit } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/AppConsts';
import { max, isMoment, Moment } from 'moment';

export const LAST_UPDATE_DATE_NOT_AVAILABLE = "N/A";
export const LAST_UPDATE_DATE_DISPLAY_FORMAT = "DD/MM/YYYY HH:mm";

@Component({
    templateUrl: './footer.component.html',
    selector: 'footer-bar',
    styleUrls: ['./footer.component.less']
})
export class FooterComponent extends AppComponentBase implements OnInit {
    releaseDate: string;
    lastImport: string = LAST_UPDATE_DATE_NOT_AVAILABLE;
    lastTheatreImport: string = LAST_UPDATE_DATE_NOT_AVAILABLE;
    lastPtlImport: string = LAST_UPDATE_DATE_NOT_AVAILABLE;
    lastPasImport: string = LAST_UPDATE_DATE_NOT_AVAILABLE;
    fourEyesLogo = AppConsts.appBaseUrl + '/assets/common/images/foureyes.png';

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        this.releaseDate = this.appSession.application.releaseDate.format(
            'YYYYMMDD'
        );
        this.initializeLastUpdateDates();
    }

    private initializeLastUpdateDates(): void {
        let importDates: Array<Moment> = [];
        this.lastTheatreImport = this.ifMomentPushToArrayAndParse(this.appSession.tenant.lastTheatreImport, importDates);
        this.lastPtlImport = this.ifMomentPushToArrayAndParse(this.appSession.tenant.lastPtlImport, importDates);
        this.lastPasImport = this.ifMomentPushToArrayAndParse(this.appSession.tenant.lastPasImport, importDates);
        this.lastImport = importDates.length > 0
            ? max(importDates).format(LAST_UPDATE_DATE_DISPLAY_FORMAT)
            : LAST_UPDATE_DATE_NOT_AVAILABLE;
    }

    private ifMomentPushToArrayAndParse(date: Moment, importsArray: Array<Moment>): string {
        if (isMoment(date)) {
            importsArray.push(date.clone());
            return date.format(LAST_UPDATE_DATE_DISPLAY_FORMAT);
        }
        return LAST_UPDATE_DATE_NOT_AVAILABLE;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/footer.component.ts